import * as React from 'react';
export const controlSvg = React.forwardRef(function controlSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9 6a3 3 0 1 1 0 6c-1.436 0-2.635-.915-2.93-2.263H1.393C1.038 9.737.75 9.355.75 9s.288-.724.643-.724H6.07C6.365 6.928 7.564 6 9 6Zm0 1.286a1.714 1.714 0 1 0 0 3.428 1.714 1.714 0 0 0 0-3.428ZM3 0c1.436 0 2.635.928 2.93 2.276h4.677c.355 0 .643.37.643.724 0 .355-.288.737-.643.737H5.93C5.635 5.085 4.436 6 3 6a3 3 0 1 1 0-6Zm0 1.286a1.714 1.714 0 1 0 0 3.428 1.714 1.714 0 0 0 0-3.428Z',
    }),
  );
});
controlSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var control = {
  category: 'icon',
  colorable: true,
  name: 'control',
  svg: controlSvg,
};
